<template>
  <div class="valueAddedService">
    <nav-header></nav-header>
    <div class="banner"></div>
    <section class="main sec">
      <h3 class="sec-title">增值服务</h3>
      <ul class="module-list module2">
        <li>
          <i class="icon icon1"></i>
          <div class="name">培训认证</div>
          <p class="desc">速派具有完整的工程师培训及认证体系，通过长时间的积累，可以为企业定制培训价格及课程</p>
        </li>
        <li>
          <i class="icon icon2"></i>
          <div class="name">备品备件</div>
          <p class="desc">速派依托众多合作伙伴，能够为客户提供质优价廉的电气及自动化备品备件</p>
        </li>
      </ul>
      <ul class="module-list module3">
        <li>
          <i class="icon icon3"></i>
          <div class="name">服务管理SaaS系统</div>
          <p class="desc">为企业提供工程师的全方位管理服务，帮助企业降本增效，模型化工程师能力，可视化服务流程，提高人均产出。</p>
        </li>
        <li>
          <i class="icon icon4"></i>
          <div class="name">人才派遣及猎头服务</div>
          <p class="desc">速派依托数量庞大且经过筛选的工程师储备库，为客户提供关于电力及自动化相关领域的工程师人才派遣及猎头服务</p>
        </li>
        <li>
          <i class="icon icon5"></i>
          <div class="name">广告服务</div>
          <p class="desc">速派依托众多互联网合作伙伴，能够为客户定制化的广告推广服务</p>
        </li>
      </ul>
    </section>
    <dark-footer></dark-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import DarkFooter from '@/components/darkFooter.vue'
export default {
  components:{
    NavHeader,
    DarkFooter,
  },
  data(){
    return{

    }
  },
  created() {
    
  },
  methods: {
    
  },
}
</script>
<style lang="scss">
.valueAddedService{
  padding-top: 68px;
  .banner{
    width: 100%;
    height: 500px;
    background-image: url('~static/img/service/value-service.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
  .sec{
    padding-top: 60px;
    background-color: #fff;
    .sec-title{
      font-size: 30px;
      color: #333;
      line-height: 50px;
      text-align: center;
      margin-bottom: 80px;
      &:after{
        content: "";
        display: block;
        width: 100px;
        height: 4px;
        background-color: #f75959;
        margin: 0 auto;
      }
    }
  }
  .module-list{
    overflow: hidden;
    text-align: center;
    &.module2{
      >li{
        margin-right: 226px;
        &:nth-child(2n){
          margin-right: 0;
        }
      }
    }
    &.module3{
      >li{
        margin-right: 74px;
        &:nth-child(3n){
          margin-right: 0;
        }
      }
    }
    >li{
      display: inline-block;
      vertical-align: top;
      margin-bottom: 80px;
      text-align: center;
      width: 288px;
    }
    .name{
      font-size: 20px;
      line-height: 30px;
      color: #f75959;
    }
    .desc{
      font-size: 16px;
      line-height: 24px;
      color: #333;
      margin-top: 8px;
      text-align: left;
    }
    .icon{
      display: inline-block;
      width: 156px;
      height: 156px;
      margin-bottom: 14px;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .icon1{
      background-image: url('~@/assets/service/icon_15.png');
    }
    .icon2{
      background-image: url('~@/assets/service/icon_16.png');
    }
    .icon3{
      background-image: url('~@/assets/service/icon_17.png');
    }
    .icon4{
      background-image: url('~@/assets/service/icon_18.png');
    }
    .icon5{
      background-image: url('~@/assets/service/icon_19.png');
    }
  }
}
</style>